import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';
import { isNullOrUndefined } from '@shared/utils/utils';

export function ValidateRegex(regexArray: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!isNullOrUndefined(regexArray) && regexArray.length > 0 && control.value != null && control.value !== '') {

      for (const regex of regexArray) {
        const regexVerification = new RegExp(regex);
        const isRegexOk = regexVerification.test(control.value);
        if (isRegexOk) {
          return null;
        }
      }

      return { regexNok: true };
    }
    return null;
  };
}

export function ValidateDate(rangeValues: any): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value !== '' && control.value != null) {

      let isDateOk = true;
      if (control.value === 'Invalid Date') {
        isDateOk = false;
      }
      else if (rangeValues) {
        const inputDate = moment(new Date(control.value));
        let maxDate;
        let minDate;

        if (!isNullOrUndefined(rangeValues.max) && rangeValues.max != "") {
          if (checkIfAbsoluteDate(rangeValues.max)) {
            maxDate = getMoment(rangeValues.max);
          }
          else {
            const momentMax = getMoment(splitRangeValue(rangeValues.max)[0]);
            const timeSpan = getTimeSpan(rangeValues.max);
            maxDate = addTimeSpanToDate(rangeValues.max, timeSpan, momentMax);
          }
          if (inputDate.isAfter(maxDate)) {
            isDateOk = false;
          }
        }
        if (!isNullOrUndefined(rangeValues.min) && rangeValues.min != "") {

          if (checkIfAbsoluteDate(rangeValues.min)) {
            minDate = getMoment(rangeValues.min);
          }
          else {
            const momentMin = getMoment(splitRangeValue(rangeValues.min)[0]);
            const timeSpan = getTimeSpan(rangeValues.min);
            minDate = addTimeSpanToDate(rangeValues.min, timeSpan, momentMin);
          }
          if (inputDate.isBefore(minDate)) {
            isDateOk = false;
          }
        }
      }

      if (!isDateOk) {
        return { dateNok: true };
      }

      return null;
    }
    return null;
  };
}

function splitRangeValue(rangeValue: string) {
  if (rangeValue.includes('-') || rangeValue.includes('+')) {
    return rangeValue.split(/[+-]/g);
  }
  else {
    return [rangeValue];
  }
}

function getMoment(date: string) {
  if (date === 'NOW') {
    return moment.utc();
  } else if (date == null) {
    return null;
  } else {
    return moment(date);
  }
}

function checkIfAbsoluteDate(date: string) {
  return moment(date).isValid()
}

function getTimeSpan(rangeValue: any) {
  if (!isNullOrUndefined(rangeValue)) {
    if (rangeValue.includes('-') || rangeValue.includes('+')) {
      let number = splitRangeValue(rangeValue)[1].replace(/\D/g, "");
      if (rangeValue.includes('-')) {
        return parseInt(number) * -1;
      }
      else {
        return parseInt(number);
      }
    }
    else {
      return 0;
    }
  }
  return null;
}

function addTimeSpanToDate(timespanType: any, amount: any, date: moment.Moment) {
  if (timespanType.includes('P')) {
    if (timespanType.includes('Y')) {
      //years
      return moment(date).add(amount, "years")
    }
    else if (timespanType.includes('M')) {
      //months
      return moment(date).add(amount, "months")
    }

    else if (timespanType.includes('W')) {
      //weeks
      return moment(date).add(amount, "weeks")
    }

    else if (timespanType.includes('D')) {
      //days
      return moment(date).add(amount, "days")
    }
  } else if (timespanType.includes('T')) {
    if (timespanType.includes('H')) {
      //hours
      return moment(date).add(amount, "hours")
    }
    else if (timespanType.includes('M')) {
      //minutes
      return moment(date).add(amount, "minutes")
    }

    else if (timespanType.includes('S')) {
      //seconds
      return moment(date).add(amount, "seconds")
    }
  }

  return moment(date);

}



